import { BigNumber } from '@0x/utils'
import { ChainId } from '../config/appConfig'
import { Asset } from '../lib/assetUtils'

export type TransactionType =
  | 'approval'
  | 'approve-spending'
  | 'borrow'
  | 'claim-vbzrx'
  | 'borrow-collateral'
  | 'trade-collateral'
  | 'delegate'
  | 'deposit'
  | 'extend'
  | 'get-airdrop'
  | 'lend'
  | 'migrate-token'
  | 'repay'
  | 'staking-claim'
  | 'staking'
  | 'swap'
  | 'trade-close-long'
  | 'trade-open-long'
  | 'trade-close-short'
  | 'trade-open-short'
  | 'transfer'
  | 'unlend'
  | 'unstake'
  | 'withdraw'
  | 'mint-nft'

export enum Operation {
  Trade = 'Trade',
  Borrow = 'Borrow',
  Lend = 'Lend',
  Stake = 'Stake',
}

export interface IActivityInfo {
  chainId: ChainId
  user: string
  timestamp: Date
  txHash: string
  asset: Asset
  type: string
  value: BigNumber
  operation?: Operation
  pair?: string
  leverage?: BigNumber
  collateral?: Asset
  loanId?: string
}
